import { useEffect, useRef, useState } from "react";
import { animate, useInView, useReducedMotion } from "framer-motion";

// Counts up the numeric part of a value (e.g. "6", "6+", "10K") when scrolled into view.
export const CountUp = ({ value = "", duration = 1.8, className = "", testId }) => {
  const ref = useRef(null);
  const inView = useInView(ref, { once: true, margin: "-80px" });
  const reduce = useReducedMotion();
  const match = String(value).match(/^(\D*)(\d+(?:\.\d+)?)(.*)$/);
  const target = match ? parseFloat(match[2]) : null;
  const decimals = match && match[2].includes(".") ? match[2].split(".")[1].length : 0;
  const [display, setDisplay] = useState(target === null || reduce ? String(value) : `${match[1]}${(0).toFixed(decimals)}${match[3]}`);

  useEffect(() => {
    if (target === null || reduce) {
      setDisplay(String(value));
      return undefined;
    }
    if (!inView) return undefined;
    const controls = animate(0, target, {
      duration,
      ease: [0.16, 1, 0.3, 1],
      onUpdate: (v) => setDisplay(`${match[1]}${v.toFixed(decimals)}${match[3]}`),
    });
    return () => controls.stop();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [inView, target, reduce, value]);

  return (
    <span ref={ref} data-testid={testId} className={`tabular-nums ${className}`} aria-label={String(value)}>
      {display}
    </span>
  );
};
